export const relationships = {
  "14": "Mother",
  "6": "Father",
  "17": "Fiancé(e)",
  "3": "Brother",
  "12": "Sister",
  "9": "Lawful Spouse",
  "13": "Son",
  "11": "Daughter",
  "8": "Grandmother",
  "7": "Grandfather",
  "5": "Girlfriend",
  "2": "Boyfriend",
  "1": "Aunt",
  "16": "Uncle",
  "21": "Nephew",
  "20": "Niece",
  "0": "Friend",
  "10": "Cousin",
  "300": "Father-in-law",
  "301": "Mother-in-law",
  "302": "Brother-in-law",
  "303": "Sister-in-law",
  "400": "Stepfather",
  "401": "Stepmother",
  "402": "Stepbrother",
  "403": "Stepsister"
};



// WEBPACK FOOTER //
// ./src/utils/relationshipList.js